"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _adherenceQuery = _interopRequireDefault(require("./adherenceQuery.graphql"));
var _Table = _interopRequireDefault(require("./components/Table"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FidelityComponentsChart = function FidelityComponentsChart(props) {
  // const fakeData = props.isPreview
  //     ? [
  //           {
  //               id: 1,
  //               groupName: 'Group 1 (4)',
  //               currentSession: 'Session 5',
  //               lastSession: '5/10/19',
  //               teenAdherence: 70,
  //               caregiverAdherence: 53,
  //               familyAdherence: 61,
  //           },
  //           {
  //               id: 2,
  //               groupName: 'Group 2 (5)',
  //               currentSession: 'Session 5',
  //               lastSession: '5/10/19',
  //               teenAdherence: 34,
  //               caregiverAdherence: 70,
  //               familyAdherence: 90,
  //           },
  //           {
  //               id: 3,
  //               groupName: 'Group 3 (5)',
  //               currentSession: 'Session 3',
  //               lastSession: '5/10/19',
  //               teenAdherence: 85,
  //               caregiverAdherence: 70,
  //               familyAdherence: 90,
  //           },
  //       ]
  //     : null;

  var _props$settings = props.settings,
    title = _props$settings.title,
    description = _props$settings.description,
    show = _props$settings.show,
    targetScore = _props$settings.targetScore;
  var isPreview = props.isPreview,
    query = props.query;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold',
      fontSize: '1.5em'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '0.5em'
    }
  }, description), /*#__PURE__*/_react["default"].createElement(_Table["default"], {
    query: isPreview ? _adherenceQuery["default"] : query,
    isPreview: props.isPreview,
    filters: props.filters,
    targetScore: targetScore
  })));
};
FidelityComponentsChart.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object
};
FidelityComponentsChart.defaultProps = {
  filters: {}
};
var _default = exports["default"] = FidelityComponentsChart;